export default {

    getCartData: (state) => () => {
        return state?.cartData?.data ? state?.cartData?.data : null ; 
    },
    getAddressCouponData(state){
        return state.cartData.data?.coupon
    },
    getCartProductDataByModule: (state, getters) => (type) => {

        const data = state.cartData
        if ( ! data?.data?.items) {

            return null
        }

        return data.data.items.filter( product =>  product.type === type)
    },
    getCartTotal: (state) => () => {
        return state.cartTotal;
    },
    
    getGuestData: (state) => () => {
        return state.guestData;
    },
    getaddressData: (state) => () => {
        const {$country} = useNuxtApp()
        // console.log('state.addressData', state.addressData)
        
        // if(state.addressData.billing_country_short == null){
        //     if($country.is_uk){
        //         state.addressData.shipping_country_short = 'GB'
        //         state.addressData.billing_country_short = 'GB'
        //     }
        //     if($country.is_india){
        //         state.addressData.shipping_country_short = 'IN'
        //         state.addressData.billing_country_short = 'IN'
        //     }
        // }
        return state.addressData;
    },
    geterrorData: (state) => () => {
        return state.errorData;
    },
    getAddressId: (state) => () => {
        return state.address_id;
    }
}